import { Box, Text, Tooltip } from '@a0/quantum-product';
import React from 'react';
import { NavLink } from '../NavLink';
export var DefinitionTooltip = function (_a) {
    var _b = _a.children, children = _b === void 0 ? '' : _b, dataKey = _a.dataKey, _c = _a.term, term = _c === void 0 ? {
        title: '',
        definition: '',
    } : _c;
    var title = term.title, definition = term.definition, short = term.short;
    return (React.createElement(Tooltip, { interactive: true, placement: "top", title: React.createElement(React.Fragment, null,
            React.createElement(Text, { variant: "subtitle2", color: "inherit" }, title),
            React.createElement(Text, { variant: "caption", dangerouslySetInnerHTML: { __html: short || definition } }),
            React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
                React.createElement(NavLink, { href: "/docs/glossary?term=".concat(dataKey) }, "View Glossary"))) },
        React.createElement("span", { className: "tooltip-portal-underlined-word", dangerouslySetInnerHTML: { __html: children } })));
};
